module.exports = __webpack_public_path__ + "static/media/instagram.735ab524.svg";